import request from '@/utils/request'

// 获取云端上传临时上传密钥
export function generateKeys (data) {
  return request({
    url: '/common/upload-file/generate-temp-keys',
    method: 'POST',
    data
  })
}

// 获取系统配置信息信息
export function getsystemconfig (params) {
  return request({
    url: '/common/system-config/get-info',
    method: 'GET',
    params
  })
}

// 获取当前管理员的头像等欢迎信息
export function getuserinfo (params) {
  return request({
    url: '/common/auth/user-info',
    method: 'GET',
    params
  })
}

// 主搜索详情
export function getsearchinfo (params) {
  return request({
    url: '/common/search/search',
    method: 'GET',
    params
  })
}

// 分类查询下拉列表
export function getCategoryList (params) {
  return request({
    url: '/common/search/category-list',
    method: 'GET',
    params
  })
}

// 标签查询下拉列表
export function getTagList (params) {
  return request({
    url: '/common/search/tag-list',
    method: 'GET',
    params
  })
}

// 活动状态下拉列表
export function getActivityStatusList (params) {
  return request({
    url: '/common/search/activity-status-list',
    method: 'GET',
    params
  })
}

// 采集到云库
export function setCollect (data) {
  return request({
    url: '/common/user-collect/set',
    method: 'POST',
    data
  })
}

// 获取当前登录人的im用户信息
export function getimuserinfo (params) {
  return request({
    url: '/common/im/get-user-info',
    method: 'GET',
    params
  })
}